<template>
  <ModalClose :modal="modal" asChild>
    <Button
      :label="label || t('components.buttons.submit')"
      :variant="variant"
      :padding="padding"
      :size="size"
      :disabled="disabled"
    >
      <template v-if="$slots.start" #start>
        <slot name="start" />
      </template>
      <template v-if="$slots.content" #content>
        <slot name="content" />
      </template>
      <template v-if="$slots.default" #default>
        <slot />
      </template>
      <template v-if="$slots.end" #end>
        <slot name="end" />
      </template>
    </Button>
  </ModalClose>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { Button } from "@/Components/Button";
import { ModalClose } from "@/Components/Buttons";

const { t } = useI18n();

defineProps({
  label: { type: String, required: false },
  variant: { type: String, default: "primary" },
  padding: { type: String, required: false },
  size: { type: String, required: false },
  modal: { type: String, required: false },
  disabled: { type: Boolean, default: false },
});
</script>
